(() => {
  const selector = '#MainContent #product-grid.product-grid, #MainContent .depict-grid';
  const states = new Map();
  const pixels = value => `${Math.round(value * 1000) / 1000}px`;
  let frame;

  function write(element, property, value) {
    if (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important') {
      element.style.setProperty(property, value, 'important');
    }
  }

  function layout(grid, state) {
    const candidates = [...grid.children].filter(item =>
      !item.matches('depict-grid-start-beacon, depict-grid-end-beacon, [id*="sentinel"], [class*="sentinel"], [class*="loader"], [class*="pagination"], [class*="trigger"]') &&
      (item.matches('.grid__item, .depict-content-block') || item.querySelector('.product-card-wrapper'))
    );
    const width = grid.clientWidth;
    if (!width || !candidates.length) return;
    const columns = innerWidth < 750 ? 2 : innerWidth < 990 ? 3 : 4;
    const ordered = candidates
      .map((item, index) => ({ item, index, order: Number(getComputedStyle(item).order) || 0 }))
      .sort((a, b) => a.order - b.order || a.index - b.index)
      .map(entry => entry.item);
    const leadingProducts = ordered.filter(item => item.querySelector('.product-card-wrapper')).slice(0, columns);
    const items = [...leadingProducts, ...ordered.filter(item => !leadingProducts.includes(item))];
    const gap = innerWidth < 750 ? 14 : 24;
    const verticalGap = innerWidth < 750 ? 22 : 28;
    const itemWidth = (width - gap * (columns - 1)) / columns;
    grid.classList.add('yazuri-masonry');
    grid.dataset.masonryColumns = columns;
    for (const item of state.items) if (!items.includes(item)) state.resize.unobserve(item);
    for (const item of items) {
      item.classList.add('yazuri-masonry__item');
      write(item, 'width', pixels(itemWidth));
      write(item, 'max-width', pixels(itemWidth));
      write(item, 'height', 'auto');
      write(item, 'min-height', '0px');
      write(item, 'margin', '0px');
      if (!state.items.includes(item)) state.resize.observe(item);
    }
    state.items = items;
    const heights = Array(columns).fill(0);
    const rtl = getComputedStyle(grid).direction === 'rtl';
    for (const item of items) {
      const column = heights.indexOf(Math.min(...heights));
      const left = (rtl ? columns - 1 - column : column) * (itemWidth + gap);
      write(item, 'left', pixels(left));
      write(item, 'top', pixels(heights[column]));
      heights[column] += item.getBoundingClientRect().height + verticalGap;
    }
    write(grid, 'height', pixels(Math.max(...heights) - verticalGap));
  }

  function update() {
    frame = undefined;
    document.querySelectorAll(selector).forEach(grid => {
      if (!states.has(grid)) {
        const resize = new ResizeObserver(schedule);
        resize.observe(grid);
        states.set(grid, { resize, items: [] });
      }
    });
    for (const [grid, state] of states) {
      if (!grid.isConnected) {
        state.resize.disconnect();
        states.delete(grid);
      } else layout(grid, state);
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function start() {
    update();
    new MutationObserver(records => {
      if (records.some(record => record.target instanceof Element && (
        record.target.closest(selector) || [...record.addedNodes].some(node => node instanceof Element && (node.matches(selector) || node.querySelector(selector)))
      ))) schedule();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    document.addEventListener('yazuri:products-appended', schedule);
    addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
